import React from 'react';

/**
 * Tailwind can't build class names at runtime, so each size ships its full
 * class strings. `translate-x-full` moves the knob by its own width, so the
 * 2px inset is preserved on every size without per-size translate values.
 */
const SIZES = {
  small: {
    track: 'w-9 h-5',
    knob: 'after:h-4 after:w-4',
    label: 'ms-2 text-xs',
  },
  medium: {
    track: 'w-11 h-6',
    knob: 'after:h-5 after:w-5',
    label: 'ms-3 text-sm',
  },
  large: {
    track: 'w-14 h-7',
    knob: 'after:h-6 after:w-6',
    label: 'ms-3 text-base',
  },
};

const ToggleButton = ({
  handleCheck,
  checked,
  label,
  className,
  disabled,
  size = 'medium',
}) => {
  const { track, knob, label: labelClass } = SIZES[size] ?? SIZES.medium;

  return (
    <label
      className={`relative inline-flex items-center ${
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'
      } ${className || ''}`}
    >
      <input
        type="checkbox"
        value=""
        checked={checked}
        className="sr-only peer outline-0"
        onChange={(e) => handleCheck(e)}
        disabled={disabled}
      />
      <div
        className={`${track} ${knob} bg-red-600/60 outline-0 border-red-300
              peer-focus:ring-0
              rounded-full peer peer-checked:after:translate-x-full
              rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white
              peer-checked:after:bg-green-100
              after:content-[''] after:absolute after:top-[2px] after:start-[2px]
              after:bg-white after:border-gray-200 after:border after:rounded-full
              after:transition-all peer-checked:bg-green-200`}
      ></div>
      {label && (
        <span
          className={`${labelClass} font-medium text-gray-900 dark:text-gray-300`}
        >
          {label}
        </span>
      )}
    </label>
  );
};

export default ToggleButton;